import React from 'react';
import styles from './InlineSpinner.module.css';

/**
 * InlineSpinner renders a small loading indicator to appear inline with text or buttons.
 */
const InlineSpinner: React.FC = () => (
  <span
    className={styles.inlineSpinner}
    role="status"
    aria-label="Loading"
  />
);

export default InlineSpinner;
